
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { sportsNews } from '../../../mocks/sportsData';
import { newsService, NewsItem } from '../../../services/newsService';
import Button from '../../../components/base/Button';
import { getNewsDetails, getNewsList } from '@/services/news';
import { getNewsLikeAdd, getNewsLikeOut, getNewsCommentAdd, getNewsCommentList } from '@/services/news';
import { message } from 'antd';
export default function NewsDetailPage() {
  // 评论相关 state
  const [comments, setComments] = useState<any[]>([]);
  const [newComment, setNewComment] = useState('');
  const [commentCount, setCommentCount] = useState(0);
  const [liked, setLiked] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = typeof window !== 'undefined' ? window.location : undefined;
  const [news, setNews] = useState<any | null>(null);
  const [relatedNews, setRelatedNews] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);

  const [replyingTo, setReplyingTo] = useState<{ parentId: number; targetUsername?: string } | null>(null);
  const [replyContent, setReplyContent] = useState('');

  // 拉取评论列表
  const fetchComments = async () => {
    if (!id) return;
    try {
      const res = await getNewsCommentList({ id });
      if (res && res.status === 1 && Array.isArray(res.data)) {
        setComments(res.data);
        setCommentCount(res.data.length);
      } else {
        setComments([]);
        setCommentCount(0);
      }
    } catch (err) {
      setComments([]);
      setCommentCount(0);
    }
  };

  //格式化时间
  const formatTime = (dateString: string) => {
    if (typeof dateString === 'string' && (dateString.includes('分钟前') || dateString.includes('小时前') || dateString.includes('刚刚'))) {
      return dateString;
    }
    // 兼容数字时间戳
    let date: Date;
    if (typeof dateString === 'number') {
      // 可能是时间戳，单位秒或毫秒
      date = new Date(dateString.toString().length === 10 ? dateString * 1000 : dateString);
    } else {
      date = new Date(dateString);
    }
    if (isNaN(date.getTime())) return '';
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days}天前`;
    if (hours > 0) return `${hours}小时前`;
    return '刚刚';
  };
  const handleReplyClick = (parentId: number, targetUsername?: string) => {

    setReplyingTo({ parentId, targetUsername });
    setReplyContent(''); // Clear content when opening

  };

  const handlePublishReply = () => {
    if (!replyContent.trim() || !replyingTo || !id) return;

    const finalContent = replyingTo.targetUsername ? `@${replyingTo.targetUsername}: ${replyContent}` : replyContent;

    getNewsCommentAdd({
      id: String(id),
      pid: String(replyingTo.parentId),
      content: finalContent,
    }).then(res => {
      if (res && res.status === 1) {
        setReplyingTo(null);
        setReplyContent('');
        message.success(res.info || '回复发布成功');
        // Re-fetch comments to show the new reply
        getNewsCommentList({ id: String(id) }).then(res2 => {
          if (res2 && res2.status === 1 && Array.isArray(res2.data)) {
            setComments(res2.data);
          }
        });
      } else {
        // Optional: show an error message
        console.error('Failed to publish reply:', res?.msg);
      }
    }).catch(error => {
      console.error('Error publishing reply:', error);
    });
  };


  useEffect(() => {
    fetchComments();
    const loadNewsData = async () => {
      setIsLoading(true);
      try {
        // 获取新闻详情
        const res = await getNewsDetails({ id });
        if (res && res.status === 1 && res.data) {
          setNews(res.data);
          setLiked(res.data.is_liked === 1); // 假设接口返回 is_liked 字段，1为已点赞
        } else {
          // 如果接口无数据，尝试从路由state兜底
          let fallbackNews = null;
          console.log('res:', window.history.state);
          if (window.history.state && window.history.state.usr && window.history.state.usr.news) {
            fallbackNews = window.history.state.usr.news;
          }
          setNews(fallbackNews);
        }
        // 获取相关新闻（同分类的其他新闻）
        // 可选：如果 getNewsDetails 返回 category，可再请求 getNewsList 获取同类新闻
        if (res && res.data && res.data.category) {
          const listRes = await getNewsList({ category_id: res.data.category.id || '', page_size: 10, page: 1 });
          if (listRes && listRes.status === 1 && Array.isArray(listRes.data?.lists)) {
            setRelatedNews(listRes.data.lists.filter(n => n.id !== res.data.id).slice(0, 6));
          } else {
            setRelatedNews([]);
          }
        } else {
          setRelatedNews([]);
        }
      } catch (error) {
        let fallbackNews = null;
        console.log('res:', window.history.state);
        if (window.history.state && window.history.state.usr && window.history.state.usr.news) {
          fallbackNews = window.history.state.usr.news;
        }
        setNews(fallbackNews);

        setRelatedNews([]);
        console.error('获取新闻详情失败:', error);
      } finally {
        setIsLoading(false);
      }
    };
    if (id) {
      loadNewsData();
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main className="py-2 md:py-3">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center py-6">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-loader-4-line text-green-500 text-base animate-spin"></i>
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1">正在加载新闻内容</h3>
                <p className="text-gray-500 text-xs">请稍候，精彩内容即将呈现</p>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (!news) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main className="py-2 md:py-3">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center py-6">
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className="ri-file-unknow-line text-gray-400 text-base"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">新闻不存在</h3>
              <p className="text-gray-500 mb-3 text-xs">抱歉，您访问的新闻内容不存在或已被删除</p>
              <Button onClick={() => navigate('/news')} size="sm">
                返回新闻列表
              </Button>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // 生成完整的新闻内容
  const generateFullContent = (news: any) => {
    const categoryName = typeof news.category === 'object' ? news.category?.name : news.category || '';
    const paragraphs = [
      news.summary,
      `据最新消息，${categoryName}领域又有重要进展。相关人士表示，这一事件将对整个体育界产生深远影响。`,
      `专业分析师认为，从技术层面来看，此次事件展现了${categoryName}运动的最新发展趋势。参与各方都表现出了极高的专业水准和竞技精神。`,
      `现场观众反应热烈，社交媒体上相关话题讨论度持续攀升。球迷们纷纷表达了自己的看法和期待。`,
      `业内专家指出，这一事件不仅具有体育竞技价值，更体现了运动精神的传承和发扬。对于${categoryName}运动的普及和发展具有积极意义。`,
      `后续发展值得关注，我们将持续跟踪报道相关动态，为读者带来最新、最全面的资讯。`
    ];
    return paragraphs;
  };
  const fullContent = generateFullContent(news);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-2 md:py-3">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* 面包屑导航 */}
            <nav className="flex items-center space-x-1.5 text-xs text-gray-600 mb-2">
              <button onClick={() => navigate('/')} className="hover:text-green-600 cursor-pointer">首页</button>
              <i className="ri-arrow-right-s-line text-gray-400 text-xs"></i>
              <button onClick={() => navigate('/news')} className="hover:text-green-600 cursor-pointer">体育新闻</button>
              <i className="ri-arrow-right-s-line text-gray-400 text-xs"></i>
              <span className="text-gray-900">{news.category?.name || ''}</span>
            </nav>
            {/* 主要内容区 */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-3">
              {/* 新闻头图 */}
              <div className="relative h-40 md:h-48 overflow-hidden">
                <img
                  src={news.cover_img || news.image || `https://readdy.ai/api/search-image?query=professional%20sports%20news%20${encodeURIComponent(news.category?.name || '')}&width=800&height=400&seq=detail${news.id}&orientation=landscape`}
                  alt={news.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2">
                  <div className="flex items-center mb-1.5">
                    <span className="px-1.5 py-0.5 bg-green-500 text-white text-xs font-medium rounded-full">
                      {news.category?.name || ''}
                    </span>
                  </div>
                  <h1 className="text-base md:text-lg font-bold text-white leading-tight">
                    {news.title}
                  </h1>
                </div>
              </div>
              {/* 新闻信息 */}
              <div className="p-3 md:p-4">
                <div className="flex items-center justify-between mb-3 pb-2 border-b">
                  <div className="flex items-center space-x-3 text-xs text-gray-600">
                    <div className="flex items-center">
                      <i className="ri-time-line mr-0.5 text-green-600 text-xs"></i>
                      <span>发布时间：{news.add_time || news.publishTime}</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-eye-line mr-0.5 text-green-600 text-xs"></i>
                      <span>{news.read_number || news.views} 阅读</span>
                    </div>
                    <div className="flex items-center">
                      <button
                        className={`flex items-center mr-1 text-xs px-2 py-1 rounded-full transition-colors ${liked ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600 hover:bg-green-50 hover:text-green-600'}`}
                        onClick={async () => {
                          if (!news) return;
                          if (!liked) {
                            const res = await getNewsLikeAdd({ id: news.id });
                            if (res && res.status === 1) {
                              setLiked(true);
                              setNews((prev: any) => ({ ...prev, like_number: (prev.like_number || 0) + 1 }));
                            }
                          } else {
                            const res = await getNewsLikeOut({ id: news.id });
                            if (res && res.status === 1) {
                              setLiked(false);
                              setNews((prev: any) => ({ ...prev, like_number: Math.max((prev.like_number || 1) - 1, 0) }));
                            }
                          }
                        }}
                      >
                        <i className={`ri-thumb-up-line mr-0.5 text-xs ${liked ? 'text-green-600' : 'text-gray-400'}`}></i>
                        <span>{news.like_number || 0} 点赞</span>
                      </button>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-chat-3-line mr-0.5 text-green-600 text-xs"></i>
                      <span>{news.comment_number || 0} 评论</span>
                    </div>
                  </div>
                </div>
                {/* 新闻正文（HTML解码渲染） */}
                <div className="prose max-w-none">
                  <div dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(news.content || '') }} />
                </div>
                {/* 标签 */}
                <div className="mt-3 pt-2 border-t">
                  <div className="flex items-center flex-wrap gap-1">
                    <span className="text-xs text-gray-600 mr-0.5">相关标签：</span>
                    {typeof news.tags === 'string'
                      ? news.tags.split(',').map(tag => (
                        <span key={tag} className="px-1.5 py-0.5 bg-green-100 text-green-600 rounded-full text-xs hover:bg-green-200 cursor-pointer transition-colors">#{tag}</span>
                      ))
                      : null}
                  </div>
                </div>
              </div>
            </div>
            {/* 评论发布区 */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                <i className="ri-chat-3-line text-blue-500 mr-2"></i>
                发表评论
              </h3>
              <div className="flex space-x-4">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-medium">我</span>
                </div>
                <div className="flex-1">
                  <textarea
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    placeholder="写下你的评论...分享你的观点和想法"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none resize-none text-sm"
                    rows={4}
                    maxLength={1000}
                  />
                  <div className="flex items-center justify-between mt-3">
                    <div className="flex items-center space-x-3 text-sm text-gray-500">
                      <button className="flex items-center hover:text-blue-500 cursor-pointer whitespace-nowrap">
                        <i className="ri-emotion-line mr-1"></i>
                        表情
                      </button>
                      <button className="flex items-center hover:text-green-500 cursor-pointer whitespace-nowrap">
                        <i className="ri-image-line mr-1"></i>
                        图片
                      </button>
                      <span className={`${newComment.length > 900 ? 'text-red-500' : ''}`}>
                        {newComment.length}/1000
                      </span>
                    </div>
                    <Button
                      onClick={async () => {
                        if (!newComment.trim() || !id) return;
                        const res = await getNewsCommentAdd({ id, content: newComment, pid: '' });
                        if (res && res.status === 1) {
                          message.info(res.info);
                          setNewComment('');
                          fetchComments();
                        }
                      }}
                      disabled={!newComment.trim()}
                      size="sm"
                      className="whitespace-nowrap cursor-pointer"
                    >
                      发布评论
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {/* 评论列表 */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="font-semibold text-gray-900 mb-6 flex items-center">
                <i className="ri-message-line text-blue-500 mr-2"></i>
                全部评论 ({commentCount})
              </h3>
              {comments.length > 0 ? (
                <div className="space-y-6">
                  {comments.map((comment) => (
                    <div key={comment.id} className="space-y-4">
                      {/* 主评论 */}
                      <div className="flex space-x-4">
                        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                          <span className="text-white font-medium text-sm">{(comment.username || '').charAt(0)}</span>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center space-x-2 mb-2">
                            <h5 className="font-medium text-gray-900 text-sm">{comment.username}</h5>
                            {comment.isVerified && (
                              <i className="ri-verified-badge-fill text-blue-500 text-sm"></i>
                            )}
                            <span className="text-sm text-gray-500">{formatTime(comment.add_time)}</span>
                          </div>
                          <p className="text-gray-700 mb-3 leading-relaxed text-sm">{comment.content}</p>
                          <div className="flex items-center space-x-4">
                            <button
                              onClick={() => {
                                setComments(prev => prev.map(c => c.id === comment.id ? { ...c, likes: c.likes + 1 } : c));
                              }}
                              className="flex items-center space-x-1 text-gray-600 hover:text-red-500 transition-colors cursor-pointer"
                            >
                              <i className="ri-heart-line text-sm"></i>
                              <span className="text-sm">{comment.likes}</span>
                            </button>
                            <button onClick={() => handleReplyClick(comment.id, comment.username)} className="text-sm text-gray-600 hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap">
                              回复
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* 回复评论 */}
                      {comment.child && comment.child.length > 0 && (
                        <div className="ml-14 space-y-4">
                          {comment.child.map((reply: any) => (
                            <div key={reply.id} className="flex space-x-3">
                              <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                                <span className="text-white font-medium text-xs">{(reply.username || '').charAt(0)}</span>
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center space-x-2 mb-1">
                                  <h6 className="font-medium text-gray-900 text-sm">{reply.username}</h6>
                                  {reply.isVerified && (
                                    <i className="ri-verified-badge-fill text-blue-500 text-xs"></i>
                                  )}
                                  <span className="text-xs text-gray-500">{formatTime(reply.add_time)}</span>
                                </div>
                                <p className="text-gray-700 text-sm mb-2 leading-relaxed">
                                  {reply.replyTo && (
                                    <span className="text-blue-600 mr-1">@{reply.replyTo}</span>
                                  )}
                                  {reply.content}
                                </p>
                                <div className="flex items-center space-x-3">
                                  <button
                                    onClick={() => {
                                      setComments(prev => prev.map(c => c.id === comment.id ? {
                                        ...c,
                                        replies: c.replies.map((r: any) => r.id === reply.id ? { ...r, likes: r.likes + 1 } : r)
                                      } : c));
                                    }}
                                    className="flex items-center space-x-1 text-gray-600 hover:text-red-500 transition-colors cursor-pointer"
                                  >
                                    <i className="ri-heart-line text-xs"></i>
                                    <span className="text-xs">{reply.likes}</span>
                                  </button>
                                  <button onClick={() => handleReplyClick(reply.id, reply.username)} className="text-xs text-gray-600 hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap">
                                    回复
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Reply Input Area */}
                      {replyingTo && replyingTo.parentId === comment.id && (
                        <div className="ml-14 mt-4">
                          <textarea
                            value={replyContent}
                            onChange={(e) => setReplyContent(e.target.value)}
                            placeholder={replyingTo.targetUsername ? `回复 @${replyingTo.targetUsername}` : '添加回复...'}
                            className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 outline-none resize-none text-sm"
                            rows={3}
                            autoFocus
                          />
                          <div className="flex justify-end items-center mt-2 space-x-3">
                            <button onClick={() => setReplyingTo(null)} className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded-md">取消</button>
                            <Button
                              onClick={handlePublishReply}
                              disabled={!replyContent.trim()}
                              size="sm"
                              className="whitespace-nowrap cursor-pointer"
                            >
                              发布
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-chat-3-line text-gray-400 text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">暂无评论</h3>
                  <p className="text-gray-500">成为第一个发表评论的人吧！</p>
                </div>
              )}
            </div>
            {/* 返回按钮 */}
            <div className="mt-3 text-center">
              <Button
                onClick={() => navigate('/news')}
                variant="outline"
                size="sm"
                className="text-xs px-3 py-1 whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-0.5 text-xs"></i>
                返回新闻列表
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

// HTML实体解码工具
function decodeHTMLEntities(text: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = text;
  return txt.value;
}